module.exports = __webpack_public_path__ + "img/1557614081938104322.0820af19.png";